import React from "react";
export default function NoDataFoundTemplate({
	width = 64,
	height = 64,
	className,
}) {
	return (
		<div className={`flex w-fit mx-auto my-4 ${className}`}>
			<img
				src={`${process.env.PUBLIC_URL}/assets/images/error.png`}
				alt="no data found logo"
				className="text-center mx-auto"
				style={{ width: width, height: height }}
			/>
			<h1 className="font-bold my-auto">NO DATA FOUND</h1>
		</div>
		//     <div className="mx-auto">
		//     <img
		//         src={`${process.env.PUBLIC_URL}/assets/images/no_data_found.png`}
		//         alt="no data found logo"
		//         className="text-center mx-auto"
		//         style={{ width: width, height: height }}
		//     />
		//     <h1 className="font-bold text-xl my-auto">NO DATA FOUND</h1>
		// </div>
	);
}
